function extractFileNameFromImageSrc(src) {
  const fileName = decodeURIComponent(
    (src.split("?filename=")[1] ?? "").split("&")[0] ?? ""
  );
  return fileName.replace(
    /(_[0-9]+)?(\.thumb)?\.[0-9a-f]{10,20}\.jpg/i,
    ".jpg"
  );
}

export { extractFileNameFromImageSrc };
//# sourceMappingURL=extractFileNameFromImageSrc.js.map
